import forEach from '../../../../javascripts/dom/forEach';

const sliders = document.querySelectorAll('[data-js-module="m-slider"]');

const init = async () => {
  const { default: Slider } = await import(/* webpackChunkName: "m-slider" */ './slider');
  forEach(sliders, (index, element) => new Slider(element));
};

if (sliders.length) init();
